import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { Box, Typography, Stack } from '@mui/material'
import Input from 'components/generic/form/Input'
import CommodityAutocomplete from 'components/generic/form/AsyncAutocomplete/CommodityAutocomplete'
import Checkbox from 'components/generic/form/Checkbox'

const GeneralPropertiesForm = ({
  setMaterialName,
  setMaterialCode,
  materialNameDuplicated,
  materialCodeDuplicated,
  isWasteMaterial,
}) => {
  const {
    control,
    clearErrors,
    formState: { errors },
  } = useFormContext()

  return (
    <Stack key="general-properties" flexGrow={1} ml={4}>
      <Typography variant="h5">General Properties</Typography>
      <Stack mt={3} mb={3} spacing={2}>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Input
            name="general.materialName"
            label="Name of Material"
            data-test="general-material-name"
            defaultValue=""
            control={control}
            error={materialNameDuplicated ? true : !!errors?.general?.materialName}
            helperText={
              materialNameDuplicated ? 'This material name is already in use' : errors.general?.materialName?.message
            }
            onChange={e => {
              clearErrors('general.materialName')
              setMaterialName(e.target.value)
            }}
          />
        </Box>
        <Box width={{ xs: '100%', md: '50%' }}>
          <CommodityAutocomplete
            name="general.commodity"
            label="Commodity"
            data-test="general-commodity"
            variant="outlined"
            control={control}
            freeSolo={false}
            error={!!errors.general?.commodity}
            helperText={errors.general?.commodity?.message}
            onChange={() => clearErrors('general.commodity')}
          />
        </Box>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Input
            name="general.materialCode"
            label="Material Code"
            data-test="general-material-code"
            defaultValue=""
            control={control}
            error={materialCodeDuplicated ? true : !!errors?.general?.materialCode}
            helperText={
              materialCodeDuplicated ? 'This material code is already in use' : errors.general?.materialCode?.message
            }
            onChange={e => {
              clearErrors('general.materialCode')
              setMaterialCode(e.target.value)
            }}
            disabled={isWasteMaterial}
          />
        </Box>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Input
            name="general.isriCode"
            label="ISRI Code"
            data-test="general-isri-code"
            defaultValue=""
            control={control}
            error={!!errors?.general?.isriCode}
            helperText={errors.general?.isriCode?.message}
          />
        </Box>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Input
            name="general.accountingCode"
            label="Income Code"
            data-test="general-accounting-code"
            defaultValue=""
            control={control}
            error={!!errors?.general?.accountingCode}
            helperText={errors.general?.accountingCode?.message}
          />
        </Box>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Input
            name="general.accountingExpenseCode"
            label="Expense Code"
            data-test="general-accounting-expense-code"
            defaultValue=""
            control={control}
            error={!!errors?.general?.accountingExpenseCode}
            helperText={errors.general?.accountingExpenseCode?.message}
          />
        </Box>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Input
            name="general.notes"
            label="Notes"
            data-test="general-notes"
            defaultValue=""
            control={control}
            error={!!errors?.general?.notes}
            helperText={errors.general?.notes?.message}
          />
        </Box>
        <Box width={{ xs: '100%', md: '50%' }}>
          <Checkbox
            name="general.tareWeightRequired"
            data-testid="tare-weight-required"
            label="Require tare weight"
            control={control}
          />
        </Box>
      </Stack>
    </Stack>
  )
}

GeneralPropertiesForm.propTypes = {
  setMaterialName: PropTypes.func,
  setMaterialCode: PropTypes.func,
  materialNameDuplicated: PropTypes.bool,
  materialCodeDuplicated: PropTypes.bool,
  isWasteMaterial: PropTypes.bool,
}

GeneralPropertiesForm.defaultProps = {
  setMaterialName: () => {},
  setMaterialCode: () => {},
  materialNameDuplicated: false,
  materialCodeDuplicated: false,
  isWasteMaterial: false,
}

export default GeneralPropertiesForm
